// extracted by mini-css-extract-plugin
module.exports = {"form":"LoginTokenForm_form__fY7hG","error-label":"LoginTokenForm_error-label__2HnrU","buttons":"LoginTokenForm_buttons__3O4Ad"};